import cn from "classnames";
import { TableCellProps } from "./types";
import styles from "./styles.module.scss";

export const TableCell = ({
  children,
  hidden,
  textAlign = "left",
  colSpan,
  className,
  dataTestId,
  ...restProps
}: TableCellProps) => {
  if (hidden) {
    return null;
  }

  return (
    <td
      className={cn(styles["table-cell"], styles[textAlign], className)}
      data-test-id={dataTestId}
      colSpan={colSpan}
      {...restProps}
    >
      {children}
    </td>
  );
};
